import styled from 'styled-components';

/**
 * Where a host lets the services block portal its Print button in. The button arrives already
 * built, so the host cannot style it directly - it sizes the slot instead, and Print comes out as
 * wide as the buttons it stands next to rather than the one small box in the row. Empty (no
 * services yet) the slot takes no room, so it leaves no gap behind it either.
 */
export const PrintsSlot = styled.span<{ $width?: number }>`
  &:empty {
    display: none;
  }

  & > .ant-btn {
    min-width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
  }
`;
